export function inferDistrictFromPostalPrefix(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length < 4) return null;

  const cp4 = Number(digits.slice(0, 4));
  if (!Number.isFinite(cp4)) return null;
  const cp2 = Number(String(cp4).slice(0, 2));

  // Regras específicas pedidas/mais comuns.
  if (cp4 >= 4700 && cp4 <= 4899) return "Braga";

  // Mapa base por prefixo (CP4 -> CP2).
  if (cp2 >= 10 && cp2 <= 19) return "Lisboa";
  if (cp2 >= 20 && cp2 <= 23) return "Santarém";
  if (cp2 >= 24 && cp2 <= 25) return "Leiria";
  if (cp2 >= 26 && cp2 <= 27) return "Lisboa";
  if (cp2 >= 28 && cp2 <= 29) return "Setúbal";
  if (cp2 >= 30 && cp2 <= 34) return "Coimbra";
  if (cp2 >= 35 && cp2 <= 36) return "Viseu";
  if (cp2 >= 37 && cp2 <= 39) return "Aveiro";
  if (cp2 >= 40 && cp2 <= 46) return "Porto";
  if (cp2 >= 47 && cp2 <= 48) return "Braga";
  if (cp2 === 49) return "Viana do Castelo";
  if (cp2 === 50 || cp2 === 54) return "Vila Real";
  if (cp2 === 51) return "Viseu";
  if (cp2 === 52 || cp2 === 53) return "Bragança";
  if (cp2 >= 60 && cp2 <= 62) return "Castelo Branco";
  if (cp2 >= 63 && cp2 <= 64) return "Guarda";
  if (cp2 >= 70 && cp2 <= 71) return "Évora";
  if (cp2 >= 72 && cp2 <= 73) return "Portalegre";
  if (cp2 >= 74 && cp2 <= 76) return "Setúbal";
  if (cp2 >= 77 && cp2 <= 79) return "Beja";
  if (cp2 >= 80 && cp2 <= 89) return "Faro";
  if (cp2 >= 90 && cp2 <= 94) return "Madeira";
  if (cp2 >= 95 && cp2 <= 99) return "Açores";

  return null;
}
